import { createFileRoute } from "@tanstack/react-router";
import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

import { CreateSellerPage } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

const createSellerSearchSchema = z.object({
  type: fallback(z.enum(["internal", "external"]), "internal").default(
    "external"
  )
});

export const Route = createFileRoute("/users/sellers/create")({
  validateSearch: createSellerSearchSchema,
  beforeLoad: requireAuthAndPermission,
  component: () => <CreateSellerPage />
});
